<template>
  <div>
    <div v-if="!loading">
      <h3>{{ name }}</h3>
      <merci-adhesion-content />
    </div>
    <div v-else>
      <p>Chargement de vos informations...</p>
    </div>
  </div>
</template>

<script>
import merciAdhesionContent from "./merciAdhesionContent.vue"
export default {
  props: {
    sasAdhesion: { type: Object }
  },
  components: {
    merciAdhesionContent
  },
  data() {
    return {
      name: "",
      loading: false
    }
  },
  async created() {
    if (!this.sasAdhesion) {
      this.loading = true
      this.axios
        .get(process.env.VUE_APP_BASE_URL + "adhesions/sasAdhesion?sasAdhesionId=" + this.$route.params.sasAdhesionId)
        .then((res) => {
          this.name = res.data.contactDTO.prenom
        })
        .finally(() => {
          this.loading = false
        })
    } else {
      this.name = this.sasAdhesion.contactDTO.prenom + " " + this.sasAdhesion.contactDTO.nom
    }
  }
}
</script>

<style>
</style>